Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (ctx) {
  var __t,
      __p = '';

  __p += ((__t = ctx.children.join('')) == null ? '' : __t) + '\n';
  return __p;
};